import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFavorites } from "../store/features/favoritesSlice";
import { addToCart } from "../store/features/cartSlice";
import ProductCard from "../components/ProductCard";
import { Button, EmptyState, Loader, PageHeader } from "../components/ui";
import { HeartIcon, ShoppingCartIcon } from "@heroicons/react/24/outline";

const FavoritesPage = () => {
  const dispatch = useDispatch();
  const { items: favorites, status } = useSelector((state) => state.favorites);

  useEffect(() => {
    dispatch(fetchFavorites());
  }, [dispatch]);

  if (status === "loading" && favorites.length === 0) {
    return <Loader className="min-h-[60vh]" />;
  }

  const addAllToCart = () => {
    favorites.forEach((fav) => dispatch(addToCart(fav.product_details)));
  };

  return (
    <div className="text-white">
      <PageHeader
        title="Избранное"
        action={
          favorites.length > 0 && (
            <Button variant="soft" size="sm" onClick={addAllToCart}>
              <ShoppingCartIcon className="w-4 h-4" />
              Все в корзину
            </Button>
          )
        }
      />

      <main className="px-2">
        {favorites.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {favorites.map((fav) => (
              <ProductCard key={fav.id} product={fav.product_details} />
            ))}
          </div>
        ) : (
          <EmptyState
            icon={HeartIcon}
            title="Ваш список пуст"
            text="Похоже, вы еще ничего не добавили в избранное. Начните просмотр нашего каталога сейчас!"
            action={
              <Button to="/" size="lg" block className="max-w-xs">
                Перейти к товарам
              </Button>
            }
          />
        )}
      </main>
    </div>
  );
};

export default FavoritesPage;
